import type React from "react";
import { ChevronRight } from "lucide-react";
import { i18n } from "@frontend/i18n";

interface RequestsInfoBannerProps {
  readonly onSentClick?: () => void;
}

export function RequestsInfoBanner({
  onSentClick,
}: RequestsInfoBannerProps): React.JSX.Element | null {
  if (onSentClick === undefined) {
    return null;
  }

  return (
    <div className="flex items-center justify-end py-3">
      {/* A pill rather than a text link: the bare link was a ~20px tap target,
          under the 24px minimum, and muted-foreground on this ground falls short
          of 4.5:1. The visible word stays "Sent" so the accessible name contains
          it, and the fuller phrase is what a screen reader announces. */}
      <button
        type="button"
        data-testid="requests-view-sent-link"
        onClick={onSentClick}
        aria-label={i18n.t("user.directory.requests.sentLinkLabel")}
        className="inline-flex min-h-11 items-center gap-1 rounded-full border border-border px-4 text-pds-2xs font-medium text-foreground transition-colors hover:bg-accent focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
      >
        {i18n.t("user.directory.requests.sentLink")}
        <ChevronRight className="h-4 w-4" />
      </button>
    </div>
  );
}
